import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
// import OrderTypeModal from '../components/OrderTypeModal'; // Import the new modal
import { CartItem, CartPageProps } from '../utils/types'; // Adjust based on your setup
import { HiShoppingCart } from "react-icons/hi";
import { MdTableRestaurant, MdBorderColor } from "react-icons/md";
import { TiHome } from "react-icons/ti";
import { isAuthenticated } from '../utils/auth';
import { HiDocumentReport } from "react-icons/hi";
import { IoLogOut, IoSettings, IoClose, IoMenu } from "react-icons/io5";
import { useCart } from '../context/CartContext'; // Import the cart context

// const Footer = () => {
const Footer: React.FC<CartPageProps> = ({ setOrderTypeModalOpen }) => {

    const location = useLocation(); // Get current route

    const navigate = useNavigate();

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // const orderType = localStorage.getItem('orderType');
    // const [orderTypeModalOpen, setOrderTypeModalOpen] = useState(false); // State for order type modal

    const handleOrderType = () => {
        setOrderTypeModalOpen(true); // Open the order type modal
        // console.log('orderTypeModalOpen', orderTypeModalOpen);
        // console.log('Selected Order Type:', orderType);
    };

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    const { cartItems, updateQuantity, removeFromCart, clearCart, setCartItems } = useCart();



    const [checkedOutItems, setCheckedOutItems] = useState<CartItem[]>([]);


    useEffect(() => {
        // Retrieve checked-out items from local storage
        // const storedCheckedOutItems = JSON.parse(localStorage.getItem('checkedOutItems') || '[]');
        // Assuming cartItems is the array provided
        const storedCheckedOutItems = cartItems.filter(item => item.checkedOut);

        // console.log('storedCheckedOutItems', storedCheckedOutItems);

        setCheckedOutItems(storedCheckedOutItems);
    }, []);

    // const isCheckedOut = (productKey: string) => {
    //     return checkedOutItems.some((item) => item.productKey === productKey);
    // };

    const [totalQuantity, setTotalQuantity] = useState(0);
    // const [totalQuantity4CO, setTotalQuantity4CO] = useState(0);

    // console.log('cartItems', cartItems, checkedOutItems);

    useEffect(() => {
        // Calculate the total quantity excluding checked-out items
        // const filteredItems = cartItems.filter((item) => !isCheckedOut(item.productKey));
        const filteredItems = cartItems.filter(item => !item.checkedOut);
        const newTotalQuantity = filteredItems.reduce((acc, item) => acc + item.quantity, 0);
        // console.log('filteredItems', filteredItems);
        // console.log('newTotalQuantity', newTotalQuantity);
        setTotalQuantity(newTotalQuantity);
    }, [cartItems, checkedOutItems]);




    return (
        <div className='footer-page'>

            {/* OrderTypeModal */}
            {/* <OrderTypeModal isOpen={orderTypeModalOpen} onClose={() => setOrderTypeModalOpen(false)} /> */}

            {isAuthenticated() && location.pathname !== '/login' && (

                <div >
                    <ul className='footer-tabs'>
                        <li className='footer-tab'>
                            <button
                                onClick={toggleMenu}
                                className={`footer-tab-btn`}>
                                <IoMenu className='footer_nav_icon' />
                                {isMenuOpen ? <IoClose /> : 'Menu'}
                                {/* onClick={() => navigate('/')} */}
                            </button>
                        </li>
                        <li className='footer-tab'>
                            <button onClick={() => navigate('/order-history')} className={`footer-tab-btn`}>
                                {/* <button onClick={handleOrderType} className={`footer-tab-btn`}> */}
                                <MdBorderColor className='footer_nav_icon' />Order List
                            </button>
                        </li>
                        <li className='footer-tab'>
                            <button onClick={() => navigate('/tables')} className={`footer-tab-btn`}>
                                <MdTableRestaurant className='footer_nav_icon' />Table
                            </button>
                        </li>
                        {/* <li className='footer-tab'>
                        <button onClick={() => navigate('/order-history')} className={`footer-tab-btn`}>
                            Order
                        </button>
                    </li> */}
                        <li className="footer-tab">
                            <button onClick={() => navigate('/cart')} className={`footer-tab-btn`}>
                                <HiShoppingCart className="footer_nav_icon" />
                                Cart&nbsp;
                                {cartItems.length > 0 && (
                                    <span className="cart-count">
                                        (&nbsp;

                                        {/* {checkedOutItems.length > 0
                                        ? totalQuantity - checkedOutItems.length // Subtract already checked-out items for existing orders
                                        : totalQuantity // Show total items for new orders
                                    } */}
                                        {totalQuantity}
                                        &nbsp;)
                                    </span>
                                )}
                            </button>
                        </li>
                    </ul>
                </div>

            )}

            {/* Wrapper to handle the overlay */}

            {isAuthenticated() && location.pathname !== '/login' && (


                <div className={`fixed inset-0 z-40 ${isMenuOpen ? 'bg-black bg-opacity-50' : 'hidden'}`} onClick={toggleMenu}>

                    {/* Mobile Menu */}
                    <div
                        className={`fixed top-0 right-0 h-full bg-white shadow-lg transition-transform duration-300 ease-in-out
                ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'} w-1/2 md:w-1/4`}
                    >
                        <nav className="flex flex-col space-y-4 mt-10 px-4 text-blue-600 text-lg">
                            {isAuthenticated() ? (
                                <>
                                    <Link to="/" onClick={toggleMenu} className="flex items-center space-x-1">
                                        <TiHome size={20} /> <span>Home</span>
                                    </Link>
                                    <Link to="/report" onClick={toggleMenu} className="flex items-center space-x-1">
                                        <HiDocumentReport size={20} /> <span>Report</span>
                                    </Link>
                                    <Link to="https://code.freegopos.com/" onClick={toggleMenu} className="flex items-center space-x-1">
                                        <IoSettings size={20} /> <span>Backend</span>
                                    </Link>
                                    <Link to="/logout" onClick={toggleMenu} className="flex items-center space-x-1">
                                        <IoLogOut size={20} /> <span>Logout</span>
                                    </Link>
                                </>
                            ) : (
                                <Link to="/login" onClick={toggleMenu}>Login</Link>
                            )}
                        </nav>
                    </div>

                </div>

            )}

            <footer className="footer-copy  ">
                <p>&copy; {new Date().getFullYear()} {process.env.REACT_APP_COMPANY_NAME} {process.env.REACT_APP_DOMAIN_NAME}. All Rights Reserved.</p>
            </footer>
        </div >
    );
};

export default Footer;
